import { format } from "date-fns";

import { createApiClient } from "@/api";
import { DEFAULT_DATE_FORMAT } from "@/constants/date";
import { type DataProviderSchema } from "@/utils";
import { checkAndThrowRequiredFieldsError } from "@/utils/errors";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/main/generated_lead_report_views";

export const leadReportSchema: DataProviderSchema<
  "GeneratedLeadReportView",
  "jsonld"
> = {
  list: async (params) => {
    const { pagination } = params;
    const { data } = await apiClient.GET(BASE_URL, {
      params: {
        query: {
          per_page: pagination?.perPage,
          page: pagination?.page,
        },
      },
    });

    return {
      data: data?.["hydra:member"] ?? [],
      total: data?.["hydra:totalItems"] ?? 0,
    };
  },
  create: async ({
    data: { dateFrom, dateTo, amount, countries, rewardType, rowsByFile },
  }) => {
    const requiredFields = [
      "dateFrom",
      "dateTo",
      "amount",
      "countries",
      "rewardType",
      "rowsByFile",
    ];

    const body = checkAndThrowRequiredFieldsError(
      {
        dateFrom: dateFrom
          ? format(new Date(dateFrom), DEFAULT_DATE_FORMAT)
          : "",
        dateTo: dateTo ? format(new Date(dateTo), DEFAULT_DATE_FORMAT) : "",
        amount: Number(amount),
        countries,
        rewardType,
        rowsByFile,
      },
      requiredFields,
    );
    const { data } = await apiClient.POST(BASE_URL, {
      body,
    });

    if (!data) throw Error("Something went wrong");

    return {
      data,
    };
  },
};
